module.exports = __webpack_public_path__ + "img/188.2f56a8f5.jpg";